import request from '@/utils/request'

// 获取所有品种实时报价（可选symbol参数获取单个）
export function getQuotes(symbol) {
  return request({ url: '/ftx/market/quotes', method: 'get', params: symbol ? { symbol } : {} })
}

// 获取报价快照（含品种详细信息）
export function getQuoteSnapshot() {
  return request({ url: '/ftx/market/quotes/snapshot', method: 'get' })
}

// 获取K线数据（游标分页）
// params: { symbol, period, limit, cursor }
// cursor 不传时取最新一页；传上一页最旧一根的 openTime 可加载更旧的数据
export function getKlineData(params) {
  return request({ url: '/ftx/market/kline', method: 'get', params })
}

// 获取最新K线
export function getLatestBar(params) {
  return request({ url: '/ftx/market/kline/latest', method: 'get', params })
}

// 获取交易对列表（含实时报价+交易参数）
export function getTradingPairs() {
  return request({ url: '/ftx/market/pairs', method: 'get' })
}

// 获取市场深度
export function getOrderBook(symbol, depth) {
  return request({ url: '/ftx/market/depth', method: 'get', params: { symbol, depth } })
}

// 行情服务健康检查
export function getMarketHealth() {
  return request({ url: '/ftx/market/health', method: 'get' })
}

// 获取市场交易时段状态
export function getMarketStatus(symbol) {
  return request({ url: '/ftx/market/status', method: 'get', params: symbol ? { symbol } : {} })
}

// 获取交易对展示点差（从 Redis Cache-Aside 读取）
export function getDisplaySpread(symbol) {
  return request({ url: `/ftx/market/spread/${symbol}`, method: 'get' })
}
